




































import { PropType } from 'vue';
import { computed, defineComponent, ref, toRefs, watch } from '@vue/composition-api';
import { AdgroupConfig, AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import ExpansionPanel from '@/components/common/expansion-panel/index.vue';
import TargetingExpansion from './index';

const name = 'ttam-targeting-expansion-compose';
export default defineComponent({
  name,
  components: {
    TtamTargetingExpansionSwitch: TargetingExpansion.TtamTargetingExpansionSwitch,
    TtamTargetingExpansionTips: TargetingExpansion.TtamTargetingExpansionTips,
    TtamTargetingExpansionTypesContainer: TargetingExpansion.TtamTargetingExpansionTypesContainer,
    TtamTargetingExpansionTypes: TargetingExpansion.TtamTargetingExpansionTypes,
    ExpansionPanel,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig } = toRefs(props);
    const adgroupId = computed(() => adgroupData.value?.adId || '');

    const _switchOn = computed({
      get() {
        return adgroupData.value.targetingExpansion?.expansion_enabled ?? false;
      },
      set(val) {
        const targetingExpansion = {
          expansion_enabled: val,
          expansion_types: val ? adgroupData.value.targetingExpansion?.expansion_types ?? [] : [],
        };
        emit('change', targetingExpansion);
      },
    });
    const _expansionTypes = computed({
      get() {
        return adgroupData.value.targetingExpansion?.expansion_types;
      },
      set(val) {
        const targetingExpansion = {
          expansion_enabled: adgroupData.value.targetingExpansion?.expansion_enabled ?? false,
          expansion_types: val,
        };
        emit('change', targetingExpansion);
      },
    });
    const { isHighlighting } = TargetingExpansion.useHighlightTargetingExpansion();
    const { targetExpansionValidator } = TargetingExpansion.useRules();
    const { targetingExpansionOptions } = TargetingExpansion.useTargetingExpansionOPtions({ adgroupData });
    const { switchDisabled, switchDisabledHint } = TargetingExpansion.usePropsSwitchDisabled({
      adgroupData,
      campaignData,
      targetingExpansionOptions,
    });
    const { appRetargetingNoSupportAlertVisible } = TargetingExpansion.useAppRetargetingNoSupportAlertVisible({
      adgroupData,
      campaignData,
      adgroupConfig,
    });
    const expansionPanelRef = ref(null);
    watch(isHighlighting, (val, oldVal) => {
      if (val && !oldVal) {
        expansionPanelRef.value?.$el?.scrollIntoView({ behavior: 'smooth' });
      }
    });
    const targetExpansionFormRef = ref(null);
    watch(
      () => adgroupData.value.targetingExpansion,
      () => targetExpansionFormRef.value?.clearValidate?.(),
      { deep: true },
    );
    return {
      name,
      adgroupId,
      isHighlighting,
      _switchOn,
      _expansionTypes,
      targetExpansionValidator,
      targetingExpansionOptions,
      switchDisabled,
      switchDisabledHint,
      appRetargetingNoSupportAlertVisible,
    };
  },
});
